export default {"src":"/_next/static/media/arrow_down.d91f108a.svg","height":14,"width":14};